// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c-hg","right":"styles_right__2xD0r"};